import { html, render } from "lit-html";
import {
	dateIterator,
	formatISODate,
	getNumMonthsContaining,
} from "@escapio/shared/l10n/date";
import {
	onChangeDates,
	travelData,
	updateDates,
} from "@escapio/portal/state/travelData";
import { formatEscapioPrice } from "@escapio/portal/state/escapio-deals-helpers";

customElements.define(
	"esc-availability-calendar-input",
	class extends HTMLElement {
		async connectedCallback() {
			const rateId = this.getAttribute("rate-id");
			const response = await fetch(`/pna/calendar/${rateId}`);
			this.availabilities = await response.json();

			onChangeDates(() => this.render());
			this.render();
		}

		render() {
			const lastPossibleDay = new Date(
				Object.keys(this.availabilities).at(-1) || "",
			);
			lastPossibleDay.setDate(lastPossibleDay.getDate() + 1);
			const numMonths = getNumMonthsContaining(new Date(), lastPossibleDay);

			const template = html`<esc-calendar-input
				.arrival=${travelData.arrival}
				.departure=${travelData.departure}
				min-duration=${this.getAttribute("min-duration")}
				.getMinDurationForDay=${date =>
					this.availabilities[formatISODate(date)]?.min_duration_for_arrival}
				max-duration=${this.getAttribute("max-duration")}
				num-months=${numMonths}
				fallback-initially-shown=${Object.keys(this.availabilities).at(0) || ""}
				@confirm=${this.confirmDates}
				.renderDayAddonsFn=${date =>
					html`<div class="calendar__addon">
						${
							this.availabilities[formatISODate(date)]
								? formatEscapioPrice(
										this.availabilities[formatISODate(date)].price,
									)
								: ""
						}
					</div>`}
				.extraValidationFn=${(start, end) =>
					dateIterator(start, end, false).every(
						date => this.availabilities[formatISODate(date)]?.price,
					)}
			></esc-calendar-input>`;
			render(template, this, { host: this });
		}

		confirmDates({ detail }) {
			updateDates(detail.arrival, detail.departure);
		}
	},
);
